/* eslint-disable react/prop-types */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
// import checkoutReducer, { actions } from 'modules/checkout';
import Typography from 'material-ui/Typography';
import Header from 'components/Header';
import Refunds from './Refunds';

@connect(
  state => ({
    user: state.user
  })
)
class Orders extends PureComponent {
  constructor(props) {
    super(props);

    let isCS = false;
    const { authToken, isAuthenticated } = props.user;
    
    if (isAuthenticated && authToken) {
      const decodedToken = jwt_decode(authToken);
      if (decodedToken.role === 'cs' || decodedToken.role === 'admin') {
        isCS = true;
      }
    }

    this.state = { isCS };
  }

  componentWillReceiveProps(nextProps) {
    const wasAuthenticated = this.props.user.isAuthenticated;
    const isAuthenticatedNow = nextProps.user.isAuthenticated;
    const authTokenPresentNow = !!nextProps.user.authToken;

    if (!wasAuthenticated && isAuthenticatedNow && authTokenPresentNow) {
      this.setIsCS(nextProps.user.authToken);
    }
  }

  setIsCS(authToken) {
    const decodedToken = jwt_decode(authToken);
    if (decodedToken.role === 'cs' || decodedToken.role === 'admin') {
      this.setState({ isCS: true });
    }
  }

  render() {
    const { isCS } = this.state;
    const { isAuthenticated } = this.props.user;
    
    if (!isCS || !isAuthenticated) {
      return (
        <div>
          <Header />
          <Typography>Please log in - customer service.</Typography>
        </div>
      );
    }

    return (
      <Switch>
        <Route path="/orders/refunds" component={Refunds} />
      </Switch>
    );
  }
}

export default Orders;


// WEBPACK FOOTER //
// ./routes/Orders/containers/index.jsx